export const IncomeWsEvents = {
    connect: 'connect',
    disconnect: 'disconnect',
    message: 'message'
};

export const OutcomeWsEvents = {
    message: 'message'
};
